import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { NAV_ITEMS } from '../data/sectionsData';

export default function Navbar({ scrolled, activeSection, scrollTo, mobileOpen, setMobileOpen }) {
    const { dark, toggleTheme } = useTheme();

    return (
        <>
            <nav className={`fixed top-0 inset-x-0 z-50 flex justify-center p-4 transition-all duration-400 ease-standard ${scrolled ? 'backdrop-blur-[20px] shadow-1' : ''}`} style={scrolled ? { backgroundColor: 'var(--nav-bg)' } : {}}>
                <div className="max-w-[1200px] w-full flex items-center justify-between">
                    <a
                        href="#top"
                        className="w-9 h-9 rounded-full flex items-center justify-center text-white text-[1.0625rem] font-bold tracking-tight shrink-0 hover:shadow-2 hover:scale-105 transition-all duration-200 ease-standard"
                        style={{ background: 'linear-gradient(135deg, #6750a4, #e91e63, #ff6d00)' }}
                        onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                    >
                        R
                    </a>

                    {/* Desktop links */}
                    <div className="hidden md:flex gap-1 items-center">
                        {NAV_ITEMS.map((item) => (
                            <a
                                key={item.id}
                                href={`#${item.id}`}
                                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ease-standard ${activeSection === item.id
                                    ? 'bg-secondary-container text-on-surface'
                                    : 'text-on-surface-variant hover:bg-surface-variant hover:text-on-surface'
                                    }`}
                                onClick={(e) => { e.preventDefault(); scrollTo(item.id); }}
                            >
                                {item.label}
                            </a>
                        ))}

                        {/* Theme toggle */}
                        <button
                            className="ml-2 w-10 h-10 rounded-full flex items-center justify-center text-lg text-on-surface-variant hover:bg-surface-variant hover:text-on-surface transition-all duration-200 ease-standard"
                            onClick={toggleTheme}
                            aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
                        >
                            <i className={dark ? 'fa-solid fa-sun' : 'fa-solid fa-moon'}></i>
                        </button>
                    </div>

                    {/* Mobile: theme toggle + hamburger */}
                    <div className="flex md:hidden items-center gap-1">
                        <button
                            className="w-10 h-10 rounded-full flex items-center justify-center text-lg text-on-surface hover:bg-surface-variant transition-colors duration-200"
                            onClick={toggleTheme}
                            aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
                        >
                            <i className={dark ? 'fa-solid fa-sun' : 'fa-solid fa-moon'}></i>
                        </button>
                        <button
                            className="w-10 h-10 rounded-full flex items-center justify-center text-xl text-on-surface hover:bg-surface-variant transition-colors duration-200"
                            onClick={() => setMobileOpen(true)}
                            aria-label="Open menu"
                        >
                            <i className="fa-solid fa-bars"></i>
                        </button>
                    </div>
                </div>
            </nav>

            {/* Mobile overlay */}
            <div
                className={`fixed inset-0 bg-black/30 z-[200] transition-opacity duration-400 ease-standard ${mobileOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
                onClick={() => setMobileOpen(false)}
            />

            {/* Mobile drawer */}
            <div className={`fixed top-0 right-0 bottom-0 w-[280px] bg-surface-container z-[201] rounded-l-2xl p-12 pl-6 flex flex-col gap-2 transition-transform duration-400 ease-emphasized ${mobileOpen ? 'translate-x-0' : 'translate-x-full'}`}>
                <button
                    className="self-end w-10 h-10 rounded-full flex items-center justify-center text-xl text-on-surface mb-6 hover:bg-surface-variant transition-colors duration-200"
                    onClick={() => setMobileOpen(false)}
                    aria-label="Close menu"
                >
                    <i className="fa-solid fa-xmark"></i>
                </button>
                {NAV_ITEMS.map((item) => (
                    <a
                        key={item.id}
                        href={`#${item.id}`}
                        className={`px-6 py-4 rounded-full text-base font-medium transition-all duration-200 ease-standard ${activeSection === item.id
                            ? 'bg-secondary-container text-on-surface'
                            : 'text-on-surface-variant hover:bg-secondary-container hover:text-on-surface'
                            }`}
                        onClick={(e) => { e.preventDefault(); scrollTo(item.id); }}
                    >
                        {item.label}
                    </a>
                ))}
            </div>
        </>
    );
}
